import React from 'react';
import { AlertModel, AlertType } from '../alerts';

export const HttpActionsAlertContext = React.createContext<AlertModel>({
  isShown: false,
  message: 'Error',
  type: AlertType.ERROR,
});
